module.exports = __webpack_public_path__ + "img/ic_search_1_active.e325094d.svg";